export const saveUtmData = () => {
  
  // If cookie already exists then skip
  if (document.cookie.indexOf("utm=") !== -1) {
    return;
  }

  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const utmData: Record<string, string> = {};
  let utmIsSet = false;
  
  // if there are utm params in url string
  if (window.location.search) {
    const urlParams = new URLSearchParams(window.location.search);
    const hasUtmParams = utmKeys.some(key => urlParams.has(key));
    if (hasUtmParams) {
      utmKeys.forEach((key) => {
        let utmDataVal: string = '';
        if (urlParams.get(key)) {
          utmDataVal = urlParams.get(key) as string;
        }
        utmData[key] = utmDataVal;
      });
      utmIsSet = true;
    }
  }

  // try to identify classic referrer if utm params are not found
  if (!utmIsSet && document.referrer) {
    var url = new URL(document.referrer);
    var hostname = url.hostname.toLowerCase();

    utmKeys.forEach((key) => {
      utmData[key] = '';
    });
     
    if (!hostname.includes(window.location.hostname.toLowerCase())) {
      utmData['utm_source'] = hostname;
      utmIsSet = true;
    }
  }
  
  if (utmIsSet) {
    document.cookie = `utm=${JSON.stringify(utmData)}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
  }
}
